import { postMethodWithTokenWIthFormData } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

export const MASS_UPLOAD_SERVICES = 'MASS_UPLOAD_SERVICES';
export const MASS_UPLOAD_SERVICES_SUCCESS = 'MASS_UPLOAD_SERVICES_SUCCESS';
export const MASS_UPLOAD_SERVICES_FAILURE = 'MASS_UPLOAD_SERVICES_FAILURE';

export const fetchMassUploadServices = () => ({
  type: MASS_UPLOAD_SERVICES,
});

export const fetchMassUploadServicesSuccess = (data) => ({
  type: MASS_UPLOAD_SERVICES_SUCCESS,
  payload: data,
});

export const fetchMassUploadServicesFailure = (error) => ({
  type: MASS_UPLOAD_SERVICES_FAILURE,
  payload: error,
});

export const massUploadServicesCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchMassUploadServices(data, external));
    try {
      const response = await postMethodWithTokenWIthFormData(
        url.massUploadServices,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchMassUploadServicesSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchMassUploadServicesFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchMassUploadServicesFailure(error.message));
    }
  };
};
